import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { LocalCurrencyNote } from './LocalCurrencyNote';
import { useCountdown } from '../hooks/useCountdown';
import { markCheckoutStarted } from '../hooks/useExitIntent';
import { PRODUCTS } from './MetaPixel';
import { Star, ShieldCheck, ChevronDown, ChevronUp, Clock, Lock, CreditCard, CheckCircle2, Mail, Instagram } from 'lucide-react';
export const Testimonials2 = () => {
  const testimonials = [{
    initials: 'MR',
    name: 'Martín R.',
    location: 'Argentina',
    product: 'Compró el Megapack',
    text: 'No me animaba a realizar colores por que me quitaba mucho tiempo. Ahora los trabajos que hago me salen 10 puntos, muy bueno lo recomiendo.',
    bg: 'bg-brandGold text-[#14100A]'
  }, {
    initials: 'CP',
    name: 'Carlos P.',
    location: 'Colombia',
    product: 'Compró el Megapack',
    text: 'Antes, los colores que hacía no me quedaban como quería. Ahora mis clientes me piden trabajos más complejos y los resultados me quedan perfectos.',
    bg: 'bg-brandSteel-deep text-white'
  }, {
    initials: 'DG',
    name: 'Diego G.',
    location: 'México',
    product: 'Compró el Megapack',
    text: 'Es muy práctico, en mi caso realize color el primer día. Aumenté el valor de mis trabajos y multiplique mis ingresos. Los videos me ayudaron para saber exactamente qué hacer.',
    bg: 'bg-brandGold text-[#14100A]'
  }, {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Uruguay',
    product: 'Compró el Megapack',
    text: 'No sabía donde estudiar. Desconfiaba de todo, pero por suerte compre este curso y viene con todo completo. Muy recomendable.',
    bg: 'bg-brandSteel-deep text-white'
  }];
  return <Section className="bg-bg-alt" data-id="element-182" data-mp="1zyd8odaoevjd">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-183" data-mp="1zzemuqmzny5b">
        <h2 className="font-display font-bold uppercase md:text-[40px] text-txt-primary mb-3 md:mb-4 text-[24px] tracking-[0.5px]" data-id="element-184" data-mp="1uz0k9o45pgeo">
          Lo que dicen{' '}
          <span className="text-brandGold" data-id="element-185" data-mp="3u5t2xhmoqx4">los Barberos</span>
        </h2>
        <div className="inline-flex items-center gap-2 bg-bg-card border border-line rounded-full px-4 py-2" data-id="element-186" data-mp="3ufk8oeet44e">
          <div className="flex text-gold" data-id="element-187" data-mp="7xvcl8jg4iba">
            {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-current" data-id="element-188" data-mp="cw58jlczvmxy" data-mpi={j} />)}
          </div>
          <span className="font-sans font-bold text-txt-primary text-sm" data-id="element-189" data-mp="htop4rx60bt2">
            4.9/5
          </span>
          <span className="font-sans text-txt-muted text-xs md:text-sm" data-id="element-190" data-mp="mqx98y1vipwy">
            · +500 barberos de Latinoamérica
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4" data-id="element-191" data-mp="vkaacna3cxu4">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-192" data-mp="10m9cxuy0bqq0" data-mpi={i}>
            <div className="bg-bg-card p-4 md:p-5 rounded-[16px] border border-line h-full flex flex-col" data-id="element-193" data-mp="15iq4kz4f0n7u">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-194" data-mp="1fohidbonshuu">
                <div className={`w-9 h-9 ${t.bg} rounded-full flex items-center justify-center font-sans font-bold text-xs shrink-0`} data-id="element-195" data-mp="1aomtfdog22cf">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-196" data-mp="11ogle7bilukn">
                  <div className="flex text-gold mb-0.5" data-id="element-197" data-mp="11physig06t5j">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-198" data-mp="1yfs8vrqh2sm7" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[13px] leading-tight" data-id="element-199" data-mp="1onw9mdcngwge">
                    {t.name}
                  </p>
                  <p className="text-[11px] font-sans text-txt-muted" data-id="element-200" data-mp="1klretbagtts6">
                    📍 {t.location}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[13px] md:text-[14px] leading-[1.5] italic mb-2.5" data-id="element-201" data-mp="2cd75phj222o7">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandGold mt-auto" data-id="element-202" data-mp="1wxsauady5slm">
                {t.product}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-bg-base" data-id="element-203" data-mp="1rww4zra1bwdk">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-204" data-mp="2fmgr2j1hj9r2">
        <div className="bg-bg-card border border-[rgba(34,197,94,0.2)] rounded-[20px] p-6 md:p-10 relative overflow-hidden" data-id="element-205" data-mp="2fmyv41ue2s9j">
          <ShieldCheck size={70} className="mx-auto text-success mb-5 md:mb-6 relative z-10" data-id="element-206" data-mp="2kn4j981g9wmv" />
          <h2 className="font-display font-bold uppercase text-[22px] md:text-[38px] leading-[1.2] tracking-[0.5px] text-txt-primary mb-6 md:mb-8 relative z-10" data-id="element-207" data-mp="2auys20j0vj8q">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body space-y-3 md:space-y-4 mb-6 md:mb-8 relative z-10" data-id="element-208" data-mp="33cksqkv44zff">
            <p data-id="element-209" data-mp="mxz76fh2hu00">
              Accedes a TODO. Ves los videos. Descargas los manuales. Los usas en tu próximo cliente.
            </p>
            <p className="font-sans font-bold text-lg md:text-xl text-txt-primary leading-snug py-2" data-id="element-210" data-mp="11lal2o0q1q3a">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-211" data-mp="8xybdefntcre" />
              devolución del 100%.
            </p>
            <p data-id="element-212" data-mp="8y6jyu4r1vws">Sin formularios. Sin complicaciones. Sin vueltas.</p>
          </div>
          <p className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-txt-muted relative z-10" data-id="element-213" data-mp="40ej3am4mzgg">
            Tasa de devoluciones: menos del 2%.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Es para alguien que recién empieza o que ya trabaja?',
    a: 'Es para ambos, para el que tiene cero conocimiento ya que explicamos desde la base, tanto como para los BARBEROS que ya trabajan y necesitan descubrir los secretos y las técnicas para dominar la colorimetría'
  }, {
    q: '¿En qué moneda pago?',
    a: 'El precio está en (USD), pero el sistema convierte automáticamente a tu moneda local en el checkout.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Instantáneamente en tu correo. Todos los videos, PDFs y bonos listos para descargar. Puedes verlo en tu celular o descargarlo e imprimirlo.'
  }, {
    q: '¿Necesito alguna certificación previa para aprovecharlo?',
    a: 'No. Solo que tengas experiencia trabajando en barbería. El sistema es progresivo: desde fundamentos hasta técnicas avanzadas.'
  }, {
    q: '¿Funciona si trabajo de forma independiente y no en una barbería?',
    a: '100%. Muchos usuarios trabajan en sus propios locales o en domicilios. El sistema se adapta.'
  }, {
    q: '¿Tiene garantía real o es un bluff?',
    a: 'Garantía real. 7 días completos. Si no te gusta, te devolvemos el dinero. Punto.'
  }, {
    q: '¿Puedo usar el megapack con mis clientes?',
    a: 'Sí. Los manuales son tuyos. Los videos también. Los bonos (fichas, cartas de color) están diseñados para usar con clientes.'
  }, {
    q: '¿Por cuánto tiempo tengo acceso?',
    a: 'Para siempre. Pago único. Acceso ilimitado.'
  }, {
    q: '¿Qué formato exacto es?',
    a: '15 Módulos en Videos MP4 HD (descargables). 4 Manuales Completos (descargables). 5 Bonos (descargables e imprimibles).'
  }, {
    q: '¿Hay actualizaciones incluidas?',
    a: 'Sí. Si agregamos nuevas técnicas o módulos, tú los recibes sin costo extra.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-bg-alt" data-id="element-214" data-mp="2gfed51evxiwg">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-215" data-mp="2bi4ohnzblb9o">
        <h2 className="font-display font-bold uppercase text-[24px] md:text-[38px] leading-[1.2] tracking-[0.5px] text-txt-primary text-center mb-8 md:mb-10" data-id="element-216" data-mp="2bhwf462eoo38">
          ❓ LO QUE MÁS NOS <span className="text-brandGold" data-id="element-217" data-mp="3vek0m0amksa3">PREGUNTAN</span>
        </h2>
        <div className="space-y-3 md:space-y-4" data-id="element-218" data-mp="39g3m58q4rtv">
          {faqs.map((faq, i) => <div key={i} className={`bg-bg-card border border-line rounded-[16px] overflow-hidden transition-colors ${openIndex === i ? 'bg-bg-highlight' : ''}`} data-id="element-219" data-mp="3lfbbbkqpg1u2" data-mpi={i}>
              <button className="w-full px-5 py-4 md:px-6 md:py-5 text-left flex justify-between items-center gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-220" data-mp="3bpja47o3oagm">
                <span className="font-sans font-bold text-[14px] md:text-[16px] text-txt-primary" data-id="element-221" data-mp="32mqke8ukg6sw">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="text-brandGold shrink-0" size={20} data-id="element-222" data-mp="2sr6zsilgcujg" /> : <ChevronDown className="text-txt-muted shrink-0" size={20} data-id="element-223" data-mp="2xp8i31b20ptv" />}
              </button>
              {openIndex === i && <div className="px-5 pb-5 md:px-6 md:pb-5 font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body border-t border-line pt-4" data-id="element-224" data-mp="2a2v5mmesud21">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: 'Años buscando en YouTube, Instagram y con otros barberos',
    costo: 'Conocimiento disperso y sin sistema'
  }, {
    sin: '3-4 horas buscando cada fin de semana',
    costo: '156-208 horas perdidas por año (4-5 semanas de trabajo)'
  }, {
    sin: 'No tener TODO en un lugar organizado',
    costo: 'Sesiones sin estructura, improvisación'
  }, {
    sin: 'Cometer errores químicos constantemente',
    costo: 'Clientes insatisfechos, mala reputación, dinero perdido'
  }, {
    sin: 'No dominar realmente las técnicas',
    costo: 'Nunca llegar a precios premium'
  }, {
    sin: 'Seguir comprando cursos sueltos y costosos',
    costo: 'Dinero y tiempo desperdiciados sin fin'
  }];
  return <Section className="bg-bg-base" data-id="element-225" data-mp="348h3r0apj00t">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-226" data-mp="306cc273tkdgt">
        <h2 className="font-display font-bold uppercase text-[26px] md:text-[40px] leading-[1.2] tracking-[0.5px] text-center text-txt-primary mb-8 md:mb-12" data-id="element-227" data-mp="307nb5tmbkx1l">
          ⚖️ ¿CUÁNTO CUESTA
          <br data-id="element-228" data-mp="3ryl3gwkryfmj" />
          <span className="text-brandGold" data-id="element-229" data-mp="3ry1krdnavn7g">NO TENERLO?</span>
        </h2>

        <div className="bg-bg-card rounded-[16px] md:rounded-[20px] overflow-hidden border border-line mb-8 md:mb-10" data-id="element-230" data-mp="3nv5803kfylbf">
          <div className="grid grid-cols-2 bg-bg-highlight p-3 md:p-5" data-id="element-231" data-mp="3iw23ck8dih3z">
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-muted" data-id="element-232" data-mp="2ch1gr558nba2">
              Sin el Megapack
            </div>
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-primary pl-3 md:pl-5 border-l border-line" data-id="element-233" data-mp="27gdetofh1a12">
              Costo real
            </div>
          </div>
          <div className="divide-y divide-line" data-id="element-234" data-mp="rzifjkkf3kg6">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 p-3 md:p-5 gap-3 md:gap-5 items-center" data-id="element-235" data-mp="vz9dq9c9x2uq" data-mpi={i}>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-txt-muted pr-2" data-id="element-236" data-mp="10svkxlzo4ej5">
                  {row.sin}
                </div>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-danger font-medium pl-3 md:pl-5 border-l border-line flex items-start gap-1.5" data-id="element-237" data-mp="1annhqnlfexcv">
                  <span aria-hidden="true" data-id="element-238" data-mp="1jolohdn91iz5">→</span> {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <p className="font-sans font-bold text-[14px] md:text-xl text-center text-txt-primary w-full mx-auto" data-id="element-239" data-mp="3lh9u1tnd8ii3">
          Tu próximo color puede ser diferente ...
        </p>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds,
    isUrgent
  } = useCountdown();
  const accent = isUrgent ? 'text-danger' : 'text-brandGold';
  return <Section className="bg-bg-alt border-t border-line pt-12 md:pt-16 pb-20 md:pb-24" data-id="element-240" data-mp="11osplv53ftu5">
      <FadeIn className="max-w-[700px] mx-auto text-center" data-id="element-241" data-mp="xkb67x2nbijw">
        {/* Urgency intro copy */}
        <div className="mb-8 md:mb-10" data-id="element-242" data-mp="1bk2pac80rp4r">
          <p className="font-display font-bold uppercase text-[20px] md:text-[32px] leading-[1.3] tracking-[0.5px] text-txt-primary" data-id="element-243" data-mp="16mkcubusmrs0">
            Puedes seguir perdiendo{' '}
            <span className="text-brandGold" style={{
            textShadow: '0 0 12px rgba(212,162,76,0.28)'
          }} data-id="element-244" data-mp="1ldjjhhc2j68y">
              tiempo,
            </span>
            
            <br data-id="element-245" data-mp="1pdbvk40o7uj2" />o mejorar tus resultados — Desde hoy.
          </p>
          <p className="font-display font-bold uppercase text-[26px] md:text-[38px] leading-[1.2] tracking-[0.5px] text-brandGold animate-pulse mt-3" data-id="element-246" data-mp="1paz49090w7tc">
            Tú decides.
          </p>
        </div>

        <div className="mb-10 md:mb-12" data-id="element-247" data-mp="2dvudg5vbovf5">
          <div className="inline-flex items-center gap-1.5 bg-danger/15 border border-danger/40 text-danger font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 rounded-full mb-3 animate-pulse" data-id="element-248" data-mp="1zyp1jp8xh2bz">
            <span className="w-1.5 h-1.5 rounded-full bg-danger animate-pulse" data-id="element-249" data-mp="1q7kmyqn5zjho"></span>
            🚨 ÚLTIMA OPORTUNIDAD
          </div>
          <h3 className={`font-sans font-bold uppercase tracking-[1.5px] text-[11px] mb-3 md:mb-4 ${accent}`} data-id="element-250" data-mp="1v0vw4yfg8ccr">
            ⏰ EL PRECIO DE LANZAMIENTO CIERRA EN:
          </h3>
          <div className={`inline-flex items-center gap-2 md:gap-3 bg-bg-card border-2 px-5 py-3 md:px-6 md:py-4 rounded-[14px] transition-colors ${isUrgent ? 'border-danger shadow-[0_0_30px_rgba(239,68,68,0.45)] animate-red-glow' : 'border-brandGold shadow-[0_0_30px_rgba(212,162,76,0.35)] animate-glow-button'}`} data-id="element-251" data-mp="1l6wx48ao98p1">
            {[hours, minutes, seconds].map((unit, i) => <React.Fragment key={i} data-id="element-252" data-mp="ugrbn96ugkbo" data-mpi={i}>
                {i > 0 && <span className={`font-display font-bold text-[30px] md:text-[40px] leading-none ${accent}`} data-id="element-253" data-mp="qh0duliwh3xn">
                    :
                  </span>}
                <span className={`font-display font-bold text-[30px] md:text-[40px] leading-none ${accent}`} data-id="element-254" data-mp="gi1btlsn46jm">
                  {unit.toString().padStart(2, '0')}
                </span>
              </React.Fragment>)}
          </div>
          <p className="font-sans font-bold text-[11px] md:text-[13px] text-danger mt-3 uppercase tracking-[1.5px]" data-id="element-255" data-mp="25xr362ldav4n">
            Después sube. No vuelve a este precio.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10 md:mb-12" data-id="element-256" data-mp="3jtiksa08xpc0">
          <div className="bg-bg-card rounded-[22px] p-5 md:p-8 border-2 border-brandGold text-left shadow-[0_0_50px_rgba(212,162,76,0.18)]" data-id="element-257" data-mp="3jt0k916jwoya">
            <h4 className="font-display font-bold uppercase text-[16px] md:text-[22px] leading-[1.25] tracking-[0.5px] text-txt-primary text-center" data-id="element-258" data-mp="3tik1y3ij2crk">
              MEGAPACK COLORIMETRÍA{' '}
              <span className="text-brandGold" data-id="element-259" data-mp="30uo6t38lwsww">LISTA™</span>
            </h4>
            <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted text-center mt-2 mb-3 md:mb-4" data-id="element-260" data-mp="30wr84jf7m8gx">
              Lo que incluye:
            </p>

            <ul className="space-y-2 md:space-y-2.5" data-id="element-261" data-mp="39x7b7rs1jdl9">
              {['15 Módulos en Video HD — 15 horas de entrenamiento', '4 Manuales Completos — 475+ páginas organizadas', '5 Bonos listos para imprimir — Sin costo extra', 'TODO lo que necesitas dominar en un solo acceso', 'Acceso inmediato y para siempre'].map(item => <li key={item} className="flex items-start gap-2" data-id="element-262" data-mp="2m5rrdxhmqrec">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-263" data-mp="2m7kpgoe6g3aq" />
                  <span className="font-sans text-[12.5px] md:text-[15px] leading-[1.45] text-txt-body" data-id="element-264" data-mp="2v5ocxq8q3a56">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-4 md:mt-5 pt-3 md:pt-4 border-t border-line text-center" data-id="element-265" data-mp="22iabbeu2xqeq">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted" data-id="element-266" data-mp="2h6wwhx6e1cdv">
                Valor original
              </p>
              <p className="font-display font-bold text-[20px] md:text-[26px] leading-none line-through text-danger mt-1" data-id="element-267" data-mp="2cdvg1kqj94s6">
                USD $155
              </p>
            </div>

            <div className="mt-3 md:mt-4 rounded-[16px] border border-brandGold/30 bg-bg-alt px-4 py-3.5 md:py-5 text-center" data-id="element-268" data-mp="1jowyaoqbo4ne">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-brandGold" data-id="element-269" data-mp="3zf7sln0twhf">
                Acceso completo hoy por
              </p>
              <p className="font-display font-bold text-[40px] md:text-[54px] leading-none text-brandGold mt-1" data-id="element-270" data-mp="3mbljy3wgjvvv">
                $15{' '}
                <span className="font-sans font-bold text-[14px] md:text-[18px] align-middle" data-id="element-271" data-mp="hyycf4gmipoz">
                  USD
                </span>
              </p>
              <p className="font-sans font-bold text-[11px] md:text-[13px] text-success mt-2" data-id="element-272" data-mp="mwgo32m0zj0o">
                90% de descuento — Solo en lanzamiento
              </p>
              <p className="font-sans text-[10.5px] md:text-[13px] text-txt-muted mt-1.5" data-id="element-273" data-mp="dwjtylgv9ry8">
                Pago único · Acceso inmediato
              </p>
            </div>

            <LocalCurrencyNote className="mt-3 md:mt-4" data-id="element-274" data-mp="2yodo0ckx5z6i" />

            <div className="mt-4 md:mt-5" data-id="element-275" data-mp="2ylr4rfoo1v8g">
              <CTAButton href={PRODUCTS.megapack.checkoutUrl} fullWidth trackingProduct="megapack" onClick={markCheckoutStarted} className="!py-3.5 md:!py-4 !text-[14px] md:!text-base" data-id="element-276" data-mp="3pefja4yzemb5">
                🔥 QUIERO EL MEGAPACK COMPLETO
              </CTAButton>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 font-sans text-[12px] md:text-[13px] text-txt-muted" data-id="element-277" data-mp="cx1xjky9r670">
          <span className="flex items-center gap-2" data-id="element-278" data-mp="7y7goojv3rpj">
            <Lock size={14} data-id="element-279" data-mp="36pfq0hu9r4k" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-280" data-mp="34w6cdfucssv">
            <Clock size={14} data-id="element-281" data-mp="3ue1vqc6zjyiw" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-282" data-mp="vn9u1k7gqye8">
            <ShieldCheck size={14} data-id="element-283" data-mp="vo1oust8ks3g" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2" data-id="element-284" data-mp="qw1oiz997x6c">
            <CreditCard size={14} data-id="element-285" data-mp="y7y3lf4mqffd" /> Tarjeta | Débito | Pago local en tu moneda
          </span>
        </div>
      </FadeIn>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-bg-base border-t border-line py-12 px-6" data-id="element-286" data-mp="138m4qtmkocnb">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-287" data-mp="184awwbw9ir9l">
        <div data-id="element-288" data-mp="1d5i6mghyu0iw">
          <h2 className="font-display font-bold uppercase tracking-[0.5px] text-base md:text-xl text-txt-primary mb-1 leading-snug" data-id="element-289" data-mp="1d6075pbnv0wm">
            🎨 MEGAPACK COLORIMETRÍA LISTA™
          </h2>
          <p className="font-sans font-bold text-sm text-brandGold" data-id="element-290" data-mp="1m4vifftkb16s">
            by NERO BARBER
          </p>
        </div>

        <p className="font-sans text-[13px] text-txt-muted max-w-md mx-auto" data-id="element-291" data-mp="1qwvn1lkkui9p">
          El megapack profesional número 1 para barberos en Latinoamérica.
          Porque aprender disperso en 10 lugares es perder años. Aquí lo tienes
          TODO: videos, manuales, fórmulas exactas y bonos de impacto.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 font-sans text-[13px] text-txt-muted pt-4" data-id="element-292" data-mp="24u21j3y9put4">
          <a href="mailto:Soportenerobarber@gmail.com" className="inline-flex items-center gap-1.5 hover:text-txt-primary transition-colors" data-id="element-293" data-mp="39atj3v3pd7i1">
            <Mail size={14} aria-hidden="true" data-id="element-294" data-mp="3ecskizfvtucc" />
            Soportenerobarber@gmail.com
          </a>
          <a href="https://www.instagram.com/Nero_barber_ok" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 hover:text-txt-primary transition-colors" data-id="element-295" data-mp="3nb4bx3okow5u">
            <Instagram size={14} aria-hidden="true" data-id="element-296" data-mp="wup2z0ajw76" />
            @Nero_barber_ok
          </a>
        </div>

        <div className="pt-8 border-t border-line space-y-3" data-id="element-297" data-mp="5u3975502ab2">
          <p className="font-sans text-xs text-txt-faint" data-id="element-298" data-mp="9wq3dcp587bf">
            © 2025 NERO BARBER. Todos los derechos reservados. Precios en
            dólares (USD) · Cobro en tu moneda local.
          </p>
          <p className="space-x-4 font-sans text-xs text-txt-faint" data-id="element-299" data-mp="1zdv6wbo97tzc">
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-300" data-mp="1ue8qxuh1jzmu">
              Términos y condiciones
            </a>
            <span data-id="element-301" data-mp="1qbvmrahy09s6">·</span>
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-302" data-mp="1qdgkf8zk08u9">
              Política de privacidad
            </a>
          </p>
        </div>
      </div>
    </footer>;
};